import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: 25,
    [theme.breakpoints.down("sm")]: {
      minHeight: 137,
      margin: "25px 0",
      textAlign: "center",
    },
  },
  searchBarTitle: {
    marginBottom: 10,
    textAlign: "center",
    fontWeight: 400,
  },
  flexContainer: {
    marginBottom: "25px",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      justifyContent: "space-around",
    },
  },
  buttonLink: {
    borderRadius: 17,
    margin: "0 12px",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      marginRight: 20,
    },
    "&:hover": {
      backgroundColor: "#ffdad4",
    },
  },
  highlightLink: {
    backgroundColor: "#ffdad4",
  },
  pageLinks: {
    fontSize: 14,
    marginLeft: 20,
    padding: 12,
    [theme.breakpoints.up("md")]: {
      whiteSpace: "nowrap",
    },
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
  headerSearchBar: {
    display: "flex",
    gap: 12,
    paddingTop: 16,
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
      justifyContent: "space-evenly",
    },
  },
  stickyHeader: {
    position: "fixed",
    alignItems: "center",
    left: 0,
    right: 0,
    top: 0,
    zIndex: 10000,
    backgroundColor: theme.palette.secondary.light,
    [theme.breakpoints.up("md")]: {
      height: 95,
    },
    [theme.breakpoints.down("sm")]: {
      height: 60,
    },
  },
  navbar: {
    position: "absolute",
    left: 0,
    right: 0,
    [theme.breakpoints.up("md")]: {
      height: 95,
    },
    [theme.breakpoints.down("sm")]: {
      height: 40,
    },
  },
  searchButton: {
    height: 48,
    borderRadius: 4,
    paddingLeft: 60,
    paddingRight: 60,
    maxWidth: 250,
  },
  locationTextField: {
    height: 48,
    minWidth: 140,
    padding: 3,
    borderRadius: 4,
    backgroundColor: theme.palette.bkg.primary,
  },
  customSelect: {
    height: 48,
    width: "auto",
    minWidth: 170,
    padding: 3,
    marginBottom: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.bkg.primary,
    "& > select, & > div": {
      padding: "11px",
    },
  },
  customAutocomplete: {
    minWidth: 150,
    borderRadius: 4,
    backgroundColor: theme.palette.bkg.primary,
    "& > label": {
      top: 5,
    },
    "& > div": {
      height: 48,
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 170,
    },
  },
}));
